// V160.14.1: WebP-Only Strategy - Cloudinary optimizer utilities

export interface CloudinaryOptions {
  width?: number;
  height?: number;
  crop?: 'fill' | 'fit' | 'scale';
  gravity?: 'faces' | 'center' | 'auto';
  quality?: 'auto' | number;
  format?: 'webp' | 'auto'; // ✅ ONLY WebP or auto (no jpeg)
}

/**
 * Returns an optimized Cloudinary URL in WebP (or auto) format.
 * Example transform: w_512,h_512,c_fill,g_faces,q_auto,f_webp
 */
export function getOptimizedImageUrl(
  url: string,
  options: CloudinaryOptions = {}
): string {
  if (!url) return url;

  const {
    width = 512,
    height = 512,
    crop = 'fill',
    gravity = 'faces',
    quality = 'auto',
    format = 'webp', // ✅ DEFAULT to WebP
  } = options;

  // V219: Handle Google profile photos (lh3.googleusercontent.com)
  // Format: ...=s{size} at the end of URL
  if (url.includes('googleusercontent.com')) {
    // Use the larger dimension to ensure high quality
    const targetSize = Math.max(width, height);
    // Remove existing size parameter and add new one
    const baseUrl = url.replace(/=s\d+(-c)?$/, '');
    return `${baseUrl}=s${targetSize}`;
  }

  // Handle Cloudinary URLs
  if (url.includes('cloudinary.com')) {
    const transforms = [
      `w_${width}`,
      `h_${height}`,
      `c_${crop}`,
      `g_${gravity}`,
      `q_${quality}`,
      `f_${format}`,
    ].join(',');

    return url.replace('/upload/', `/upload/${transforms}/`);
  }

  // Return original URL for other providers
  return url;
}


